(function() {
  const __dc = document.createElement('script'),
    __s = document.getElementsByTagName('script')[0],
    __url = 'j1.58cdn.com.cn/beidou-sdk/browser/bundle.min.js'

  __dc.type = 'text/javascript'
  __dc.crossOrigin = 'anonymous'
  __dc.async = false
  __dc.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') + __url
  // const wHost = window.location.host
  // const isTestV5 = wHost.includes('58v5')
  // const isOnline = wHost.includes('ehr.58corp')
  const hashParam = {
    'online': {
      projectId: 725, // 必传 ，在58北斗监控平台添加项目时，生成的项目ID
      isProd: !(process.env.NODE_ENV === 'development' || process.env.PATH_ENV === 'test' || process.env.PATH_ENV === 'sandbox'), //  非必传， 是否将捕获的异常信息发送到北斗服务器   为true时 发送上报请求 默认为true
      isDebug: false, // 非必传  是否打印日志 为true时 打印 默认为false
      overtime: 60000
    }
  }
  __dc.onload = function() {
    window.Beidou.init(hashParam['online'])
    window.Beidou.addGlobalEventProcessor((event) => {
      window.onunhandledrejection = (event) => {
        console.log(`UNHANDLEDREJECTION: ${event.reason}`)
        return null
      }
      if (['resource_success', 'api_success', 'dom', 'performance'].includes(event.type)) {
        return event
      }
      if (event.type === 'breadcrumb') {
        let index = event.breadcrumbs.findIndex((item) => {
          let status = ''
          try {
            status = JSON.parse(unescape(item.text))
          } catch (error) {
            status = ''
          }
          if (item.type === 'api') {
            return status.statusCode == 418 || status.status_code == 418 || status.statusCode == 302 || status.status_code == 302 || status.statusCode == 0 || status.status_code == 0 || status.status_code == 404 || status.statusCode == 404 || status.status_code == 408 || status.statusCode == 408
          }
          if (item.type === 'resource') {
            return status.statusCode == 404 || status.status_code == 404 || status.status_code == 302 || status.statusCode == 302
          }
        })
        if (index !== -1) {
          return null
        }
      }
      if (event.type === 'api') {
        let index = event.apis.findIndex((item) => {
          return item.statusCode === 418 || item.status_code === 418 || item.status_code == 302 || item.statusCode === 302 || item.status_code === 0 || item.statusCode === 0 || item.status_code == 404 || item.statusCode == 404 || item.status_code == 408 || item.statusCode == 408
        })
        if (index !== -1) {
          return null
        }
      }
      if (event.type === 'resource') {
        let index = event.resources.findIndex((item) => {
          return item.statusCode === 404 || item.status_code === 404
        })
        if (index !== -1) {
          return null
        }
      }
      return event
    })
  }
  __s.parentNode && __s.parentNode.insertBefore(__dc, __s)
})()



// WEBPACK FOOTER //
// ./src/utils/beidou.js